import { render, staticRenderFns } from "./ModifyOrArchivePriority.vue?vue&type=template&id=0b620054&"
import script from "./ModifyOrArchivePriority.vue?vue&type=script&lang=js&"
export * from "./ModifyOrArchivePriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports